module.exports = __webpack_public_path__ + "img/reach-us-anytime.459d1ed.svg";